/**
 * 消息统一收发处理mixin文件。
 * ！！！注意，此文件 PC/H5公用， 改动时务必注意！！！
 */

import StringUtils from '@/utils/string';
import { IMSDK, SDKUtils } from '@/imsdk/index';
import { getScrollBottom, scrollLimit } from '@/utils/scroll';
import { throttle, base64 } from '@tencent/qd-lib';
import qs from 'qs';
import { getOrFetchExtuinInfo, defaultExtuinInfo } from '@/utils/extuinInfo';
import Vue from 'vue';
import MsgRobotForm from '@/components/message-items/MsgRobotForm';
import MsgRobotDrawer from '@/components/message-items/MsgRobot/model-sub-msg/reverso-sub-msg/DrawerMsg';
import { handleLinkClick } from '@/utils/bindlLinkClick';
import scrollIntoView from 'scroll-into-view-if-needed';
import fetchCompanyInfo from '@/utils/companyInfo';

import globalWin from '@/utils/globalWin';
import { robotReport, msgTracingEvent } from '@/utils/report';
import { isPrivate } from '@/utils/env';
import { isInWhiteList } from '@/utils/whiteList';
import { myLocalStorage } from '@/utils/myLocalStorage';
import { ROBOT_REPLAY_DELAY, SWITCH_LANG } from '@/utils/api';
// import authAjax from '@/utils/authajax';
import rumHelper from '@/utils/rumHelper';

const imsdk = IMSDK.create();
// eslint-disable-next-line no-underscore-dangle
console.log('[imsdk][info]', imsdk._sid, imsdk._buildTime);

/**
 * 不是IMSDK产生的消息类型
 */
const MsgType = {
  MSG_TIP: 'MSG_TIP',
  MSG_DATETIME: 'MSG_DATETIME',
  MSG_TYPING: 'MSG_TYPING',
  /* 留言消息 */
  MSG_LEAVE_FORM: 'leave_form_msg',
  /* b 邀请C QQ聊天 */
  MSG_INVITE_QQ: 'invite_qq_msg',
  /* b 发送加好友名片 */
  MSG_ADD_QQ_CARD: 'add_qq_card_msg',
  // 机器人电商场景导航的nav消息
  MSG_ROBOT_GOODS_NAV: 'robot_goods_nav_msg',
};

export const MsgOrder = {
  Sync: 0, // 实时同步消息
  Roaming: 1, // 历史漫漫消息
};

/**
 * 消息发送状态
 */
export const MsgStatus = {
  Success: 0, // 消息发送成功
  Sending: 1, // 消息发送中
  Resend: 2,   // 消息失败重发
  Invalid: 3,  // 消息无效(比如敏感词)
};

/**
 * 消息重发类型
 */
const MsgResendType = {
  TimeOut: 0, // 超时未响应
  UploadFailed: 1, // 上传失败
};

let MaxSyncMsgTime = 0; // 最大的实时消息时间
let MinRoamingMsgTime = Date.now(); // 最小的漫游消息时间

export default {
  provide() {
    return {
      MsgType,
      MsgStatus,
      IMSDKType: IMSDK.TYPES,
      OBJTYPES: IMSDK.OBJTYPES,

      // 把消息列表也全局共享。主要是提供给图片预览列表用的。
      messageList: this.messageList,

      // 为了做响应式处理，因此这里使用了一个object
      globalData: this.globalData,
      to: this.to,
      inIframe: this.inIframe,
      // wpa配置信息
      wpaDetail: this.innerWpaDetail,
      // getWpaDetail: () => this.wpaDetail,
      switchMsgDisplay: this.switchMsgDisplay,
      transferRobotMsg: this.transferRobotMsg.bind(this),
      voiceRecodeStatus: this.voiceRecodeStatus.bind(this),
    };
  },
  props: {
    companyInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    // 是否在iframe中
    inIframe: {
      default: false,
    },

    // 背景图
    aioBgImg: {
      default: '',
    },
    isShowWatermark: {
      default: false,
    },
    /**
     * 工具栏按钮配置。
     * 按钮分为两种：
     * a. 内置功能按钮，通过 action 值来指定，也可以入传入 icon, name, title 来覆盖默认图标文字。
     * b. 外部新增按钮，需要传入 icon, name, title, 点击后会emit('click')
     */
    toolButtons: {
      default() {
        return [
          /*
          { actionType?: string, icon?: string, name?: string, title?: string, isShow: boolean, enable: boolean,  }
          */
        ];
      },
    },

    /**
     * 客服信息显示类型。1-企业，2-员工。默认企业
    */
    serviceInfoShowType: {
      default: 1,
    },

    /**
     * 接待信息
     */
    wpaDetail: {
      default() {
        return {
          kfuin: 0,
        };
      },
    },

    /**
     * 鉴权信息
     */
    authConf: {
      default() {
        return {};
      },
    },

    inputContent: {
      default: '',
    },

    // 引流配置信息
    guidanceInfo: {
      default: null,
    },
    // 样式信息
    styleConfig: {
      default() {
        return {};
      },
    },
    // 展示信息
    showInfo: {
      default() {
        return {};
      },
    },

    // 【已读回执】开关
    readStatusSwitch: {
      default: false,
    },
  },
  data() {
    return {
      // 回复消息的内容
      sourceMsg: null,
      // 输入框的内容
      sendContent: '',

      globalData: {
        // 当前播放的语音消息seq
        playingVoice: null,

        // 当前接待信息
        // 所有值均可为 undefined 。
        reception: {
          // inWaitPool: 是否在未接入池/排队
          // isRobot: 是否机器人
          // robotId: 如果是机器人，机器人的分组id
          // extuin: 人工接待时的工号或分组号
          // receptionType: 接待类型，无用。
        },

        // 机器人延迟输入配置信息。switch, time 需要从server读取。
        robotDelay: {
          switch: false, // 开关,是否延迟展示
          time: 0,   // 最大持续时间
          current: null, // 当前显示输入态的消息
          promptOpen: true, // 是否展示正在输入
        },

        // 引流相关信息
        guidanceInfo: this.guidanceInfo,

        // 用户侧与服务器的时间差
        serverClientTimeDiff: 0,
      },

      // IM是否已经准备就绪。未就绪时，工具栏不可用。
      isIMReady: false,

      // 是否加载消息中
      isLoading: false,
      // 是否有更多消息。
      isMoreMessage: false,
      // 新漫游接口是否有更多消息
      isMoreMessageNew: false,
      // 老漫游接口是否有更多消息。注意，此值在mounted之后会更新。
      isMoreMessageOld: false,

      // 漫游消息游标
      roamingMsgSeq: -1,
      // 老漫游消息游标。值为最后一条消息的时间+1
      roamingOldMsgTime: -1,

      // 全局消息表。主要是和web工作台多用户对齐的。
      // 处理wss事件推送的消息，并向下分发。
      toSyncMsgMap: {},
      toNotifyMsgMap: {},

      // 当前用户的消息。
      // 消息map
      seqMessageMap: new Map(),
      // 消息列表。消息排序显示根据此数据进行。
      messageList: [],

      // 获取未读消息的number
      notReadNumber: 0,

      // 消息接收者信息
      to: {
        id: 0, // 接待者的id。当前测试写死
        user_id: 0, // C侧用户id，即 aid。 登录成功后获得。
      },

      /**
       * 鉴权过程中的临时数据，需要传入到进线中去
       */
      authTempUserInfo: '',
      /** 客服的具体信息，通过工号拉取 */
      // createQQInviteCard
      receptionInfo: {},
      // 员工信息map
      employeeInfoMap: {},
      innerWpaDetail: {},   // 直接Provide出去没有响应式，定义一个新变量中转一下

      // 最后一次拉取漫游消息的时间。要根据这个时间来临时禁止滚动动画
      lastFetchRoamingTime: 0,
      // 当前是否正在显示踢下线提示框
      isKickAlertShowing: false,
      loginConfig: {},
      revoseMsgSeqList: [], // 机器人电商消息seq列表

      // 页面可见状态
      pageVisibile: true,
    };
  },

  computed: {
    // 通用payload信息
    commonPayload() {
      return {
        user_id: this.to.user_id,
      };
    },

    // 当前接待工号。仅人工(单人/分组)接待有效。机器人接待均返回 0 。
    currExtuin() {
      const { extuin } = this.globalData.reception;
      return extuin || 0;
    },
    // 背景图片样式
    listBgStyle() {
      const stObj = {};
      console.log('watermark:',  this.authTempUserInfo);
      if (this.isShowWatermark) {
        let u ;
        try {
          u = JSON.parse(base64.decode(this.authTempUserInfo));
        } catch (error) {
        }
        if (u && u.nickname) {
          const link = `data:image/svg+xml,%3Csvg width='135' height='135' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50%25' y='50%25' font-size='14' fill-opacity='0.2' text-anchor='middle' dominant-baseline='middle' transform='rotate(-45, 100 100)'%3E${u.nickname}%3C/text%3E%3C/svg%3E`;
          stObj.background = `url("${link}")`;
        }
      } else {
        if (this.aioBgImg) {
          stObj.backgroundImage = `url(${this.aioBgImg})`;
        }
      }
      return stObj;
    },
  },

  // 注意，下放的逻辑是将web工作台的逻辑，从用户列表移植到单一用户聊天页
  // 因此看起来有点绕。后续需要进行优化。
  watch: {
    toSyncMsgMap: {
      deep: true,
      handler(data) {
        const message = data[this.to.id];
        if (!message) {
          console.warn('☹️☹️☹️☹️☹️☹️===>msg_kfuin_error', Object.keys(data), this.to.id);
        }
        if (message && message.length > 0) {
          for (const item of message) {
            if (item.to === this.to.id) {
              // 标记实时c2b消息是否是从其他端同步过来的。应对未来C测可以多点登录的场景
              Object.assign(item, { c2bSyncFromOtherClient: true });
              this.addMessageList(item, MsgOrder.Sync, true);
            } else if (item.from === this.to.id) {
              this.addMessageList(item, MsgOrder.Sync, false);
            } else {
              console.warn('☹️☹️☹️☹️☹️☹️===>msg_kfuin_error', Object.keys(data), this.to.id);
            }

            // 在此处就需要滚动，否则有多条消息时会导致页面滚动判断错误而不进行滚动
            console.log('getScrollBottom', getScrollBottom());
            if (getScrollBottom() < scrollLimit) {
              this.scrollToBottom(true, 50);
            }
          }

          const newData = { ...data };
          newData[this.to.id] = [];
          // this.$emit('update:syncMessage', newData);
          this.toSyncMsgMap = newData;
        }
      },
    },
    toNotifyMsgMap: {
      deep: true,
      handler(data) {
        const notify = data[this.to.id];
        if (notify && notify.length > 0) {
          for (const item of notify) {
            this.showTipMessage({
              message: item.content,
            });
          }
          const newData = { ...data };
          newData[this.to.id] = [];
          // this.$emit('update:notifyMessage', newData);
          this.toNotifyMsgMap = newData;
        }
      },
    },

    // 处理外部输入的内容
    inputContent: {
      immediate: true,
      handler(val) {
        this.sendContent = val;
      },
    },
    // ---------- 下发是一些需要同步到AIO外部的变量。 ----------
    sendContent(val) {
      this.$emit('update:inputContent', val);
    },
    messageList: {
      deep: true,
      handler(val) {
        this.$emit('update:messageList', val);
        // 一旦有新消息进来，就移除 进线tip
        // 因为存在其他不通过addMsgList而直接插入messageList的情况，因此要直接watch它。
        this.removeIncomingTip();
      },
    },
    'globalData.reception': {
      deep: true,
      handler(val, oldVal) {
        this.$emit('update:reception', val);
        const oldRobotId = oldVal && oldVal.robotId;
        const { robotId, isRobot } = val;
        if (isRobot) {
          if (robotId && robotId !== oldRobotId) {
            this.fetchDelayConfig(robotId);
          }
        } else {
          // 如果不是机器人的话还原配置
          this.globalData.robotDelay = {
            switch: false, // 开关,是否延迟展示
            time: 0,   // 最大持续时间
            current: null, // 当前显示输入态的消息
            promptOpen: true, // 是否展示正在输入
          };
        }
      },
    },
    notReadNumber(val) {
      this.$emit('update:notReadNumber', val);
    },
    wpaDetail: {
      immediate: true,
      handler(val) {
        // 如果页面嵌入到了 iframe里，就要按照下面的方法赋值，否则无法触发响应
        Object.assign(this.innerWpaDetail, val);
        // 如果页面没有嵌入，就必须按照下面的方法赋值，否则无法触发响应。
        this.innerWpaDetail = val;
      },
    },

    // 页面可见状态变化
    pageVisibile: {
      immediate: true,
      handler(val) {
        console.log('[pageVisibile]', val);
        if (val) {
          // 页面可见时，通知server所有B2C消息【已读】
          // 延迟处理一下。页面可能已经断连了。
          setTimeout(() => {
            // 需要im处于已连接后
            if (this.isIMReady) {
              this.setMsgAllRead();
            }
          }, 1500);
        }
      },
    },
  },

  created() {
    // 赋值给全局，方便其他消息在消息内部调用
    globalWin.scrollToBottom = this.scrollToBottom.bind(this);
    globalWin.sendTextMessage = this.sendTextMessage.bind(this);
    globalWin.sendQDMenuMessage = this.sendQDMenuMessage.bind(this);
    globalWin.sendOnlyInvisibleMessage = this.sendOnlyInvisibleMessage.bind(this);
    globalWin.createLeaveMessage = this.createLeaveMessage.bind(this);
    globalWin.showTipMessage = this.showTipMessage.bind(this);
    globalWin.$PictureViewer = this.$PictureViewer;
    globalWin.sendQDXMLMessage = this.sendQDXMLMessage.bind(this);
    globalWin.addMessageList = this.addMessageList.bind(this);
    globalWin.checkIfNeedScrollToBottom = this.checkIfNeedScrollToBottom.bind(this);
    globalWin.addSendContent = this.addSendContent.bind(this);
    globalWin.sendLangTip = this.sendLangTip.bind(this);
    globalWin.setLangRequest = this.setLangRequest.bind(this);
    // 自动化测试暴露数据
    this.storageMessageForTest();

    // 页面可见状态变化
    document.addEventListener('visibilitychange', () => {
      this.pageVisibile = document.visibilityState === 'visible';
    });
  },

  mounted() {
    // 上报mounted
    this.customReport({
      method: 'AIO_MOUNTED',
      message: this.wpaDetail,
      referrer: document.referrer,
      // eslint-disable-next-line no-underscore-dangle
      buildTime: window.__buildTime,
    }, 'webim');
    // 上报缓存的数据
    rumHelper.report(this.customReport);

    // 注入监控信息
    this.setQdMonitor();
    this.checkIfNeedReconnect();
  },

  beforeDestroy() {
    // 移除所有消息监听
    this.removeListener();
  },

  methods: {
    // 在输入框最后追加内容
    addSendContent(text) {
      this.sendContent = this.sendContent + text;
    },
    async startIM(loginConfig) {
      // 上报mounted
      this.customReport({
        method: 'AIO_STARTIM',
        message: this.wpaDetail,
      }, 'webim');

      // 如果发现不是鉴权，则不拉取老漫游消息。
      // 注：dom型如果做鉴权时，拉取老webim可能会有问题，
      // 因为外显会进入轨迹，然后老webim漫游又会把轨迹的内容拉取出来。
      if (this.authConf.authType) {
        this.isMoreMessageOld = true;
      } else {
        this.isMoreMessageOld = false;
      }

      // show tip
      this.createIncomingTip();
      this.login(loginConfig);

      // 先移除一下绑定，防止重复绑定
      this.removeListener();
      // 事件绑定
      imsdk.on(IMSDK.EVENT.MESSAGE_RECEIVED, this.onNewMessage);
      imsdk.on(IMSDK.EVENT.NOTIFY_PUSH, this.onPushNotify);
      imsdk.on(IMSDK.EVENT.SDK_READY, this.onImsdkReady);
      imsdk.on(IMSDK.EVENT.SESSION_START, this.onSessionStart);
      imsdk.on(IMSDK.EVENT.KICKED_OUT, this.onKickedOut);
      imsdk.on(IMSDK.EVENT.LOCAL_NOTIFY, this.onLocalNotify);
      imsdk.on(IMSDK.EVENT.TYPING, this.onTyping);
      imsdk.on(IMSDK.EVENT.RECEPTION_CHANGE, this.onReceptionChange);
      imsdk.on(IMSDK.EVENT.INVITE_QQ, this.onInviteQQ);
      imsdk.on(IMSDK.EVENT.ADD_QQ_CARD, this.onReceiveQQCard);
      imsdk.on(IMSDK.EVENT.NOTIFY_RTC, this.onNotifyRtc);
      imsdk.on(IMSDK.EVENT.ERROR, this.onError);
      // 消息【已读回执】事件
      imsdk.on(IMSDK.EVENT.READ_RECEIPT, this.onMsgReadReceipt);

      // // 获取与服务器的时间差异
      // try {
      //   this.serverClientTimeDiff = await this.getServerClientTimeDiff();
      // } catch (ex) {}
    },
    /**
     * 登陆，进行IM连接
     */
    login(loginConfig) {
      const config = { ...this.wpaDetail };
      // C侧的to.id为 主号
      this.to.id = Number(config.kfuin);
      if (!loginConfig.aid) {
        this.showTipMessage({
          message: loginConfig.message || `登录失败，错误码为${loginConfig.code}`,
        });
        return;
      }
      try {
        // TOFIX: wpaDetail 信息只读，禁止在登录的时候修改。@mark
        this.to.user_id = loginConfig.aid;
        // this.to.user_id = loginConfig.aid;
        this.authTempUserInfo = loginConfig.userInfo;
        SDKUtils.loginQDIM(
          {
            aid: loginConfig.aid,
            d2: loginConfig.d2,
            kfuin: Number(config.kfuin),
            appid: loginConfig.appid,
            wpaId: config.wpaId,
          },
          {
            imsdk,
            Instant: window.Instant,
            channelType: 4, // 固定值
            cosBucket: 0, // 固定值
          },
        );
        // 注入监控信息
        // this.setQdMonitor();
      } catch (ex) {
        // im login fail, show message
        this.showTipMessage({
          message: ex.message,
        });
      }
    },

    setQdMonitor() {
      // 设置监控的uin值
      // window.QdMonitor && window.QdMonitor.setConfig({
      //   uin: aid,
      // });
      window.Instant.setLogReport((data) => {
        // Instant只上报 login 返回
        if (JSON.stringify(data).indexOf('[msg_login_rsp]') > -1) {
          this.customReport(data, 'instant上报');
        }
      });
      const report = (data) => {
        this.customReport(data, 'imsdk上报');
      };
      imsdk.setLogReport(report);
      SDKUtils.setLogReport(report);
    },
    customReport(data, name = 'webim') {
      console.log('[customReport]', data);
      // 记录一下C侧时间。
      const D = new Date();
      const T = `${D.toLocaleString()}.${D.getMilliseconds()}`;
      window.QdMonitor && window.QdMonitor.log({
        name,
        time: T,
        ext1: data,
        ext2: { aid: this.to.user_id, reception: this.globalData.reception },
      });
    },

    // 返回SDK实例，工具方法等。
    getSDKIntance() {
      return {
        imsdk,
        SDKUtils,
        IMSDK,
        MsgType, // 内置自定义消息类型
      };
    },

    // 内置按钮功能调用
    onCallFunc(...args) {
      const func = args[0];
      const moreArgs = args.slice(1);
      if (typeof (this[func]) === 'function') {
        this[func](...moreArgs);
        this.customReport({
          method: '[onCallFunc][success]',
          message: { args },
        }, 'webim');
      } else {
        console.warn('[onCallFunc-miss]', args);
        this.customReport({
          method: '[onCallFunc][fail]',
          message: { args },
        }, 'webim');
      }
    },

    // 通过复制的方式粘贴图片进行发送
    imageUploadWithCopy(args) {
      this.$refs?.imageUploader?.onHandleFiles(args);
    },

    // 触发图片选择
    imageUpload() {
      this.$refs?.imageUploader?.click();
    },

    // 触发图片选择
    fileUpload() {
      this.$refs?.fileUploader?.click();
    },

    // 机器人转人工
    robotTransfer() {
      const msgData = {
        kfuin: this.wpaDetail.kfuin,
        robotid: this.globalData.reception.robotId,
        channel: 3,
        visitid: this.to.user_id,
        transferType: 1,
        transferReason: 5,
        action: 5,
      };
      const svrId = isPrivate ? 2000002 : 1000003; // 区分私有化和saas。
      const cmdUrl = `mqqwpa://im/qdmenu?svrId=${svrId}&ext=${JSON.stringify(msgData)}`;
      handleLinkClick(cmdUrl);
    },

    // 结束会话
    closeSession() {
      this.$Confirm({ title: this.$t('chat_close_session_confirm') }).then(() => {
        const params = {
        };
        imsdk.closeSession(params);
      })
        .catch(() => { });
    },

    /**
     * 退出排队
     */
    exitQueue() {
      this.$Confirm({ title: this.$t('exit_queue_confirm') }).then(() => {
        const params = {
          kfuin: this.wpaDetail.kfuin,
          reception: this.globalData.reception,
          cid: this.to.user_id,
        };

        SDKUtils.exitQueue(params)
          .then((rs) => {
            if (!rs.code) {
              this.showTipMessage({
                message: this.$t('exit_queue_success'),
              });
              // 重置标记位
              this.globalData.reception.inWaitPool = false;
            } else {
              this.showTipMessage({
                message: this.$t('exit_queue_fail'),
              });
            }
          })
          .catch(() => {
            this.showTipMessage({
              message: this.$t('exit_queue_fail'),
            });
          });
      })
        .catch(() => { });
    },

    /**
     * 主动下发满意度
     */
    activeFeedback() {
      const params = {
        cid: this.to.user_id,
      };
      imsdk.activeFeedback(params)
        .then(() => {
          // 处理成功。
        })
        .catch((ex) => {
          // 发生错误
          this.showTipMessage({
            message: ex.message,
          });
        });
    },

    // 上屏消息通用数据
    previewMsgCommongData() {
      const time = Date.now();
      return {
        status: MsgStatus.Sending,
        time,
        to: this.to.id,
      };
    },

    // 移除所有消息监听
    removeListener() {
      imsdk.off(IMSDK.EVENT.MESSAGE_RECEIVED, this.onNewMessage);
      imsdk.off(IMSDK.EVENT.NOTIFY_PUSH, this.onPushNotify);
      imsdk.off(IMSDK.EVENT.SDK_READY, this.onImsdkReady);
      imsdk.off(IMSDK.EVENT.SESSION_START, this.onSessionStart);
      imsdk.off(IMSDK.EVENT.KICKED_OUT, this.onKickedOut);
      imsdk.off(IMSDK.EVENT.LOCAL_NOTIFY, this.onLocalNotify);
      imsdk.off(IMSDK.EVENT.TYPING, this.onTyping);
      imsdk.off(IMSDK.EVENT.RECEPTION_CHANGE, this.onReceptionChange);
      imsdk.off(IMSDK.EVENT.INVITE_QQ, this.onInviteQQ);
      imsdk.off(IMSDK.EVENT.ADD_QQ_CARD, this.onReceiveQQCard);
      imsdk.off(IMSDK.EVENT.NOTIFY_RTC, this.onNotifyRtc);
      imsdk.off(IMSDK.EVENT.ERROR, this.onError);
      // 消息【已读回执】事件
      imsdk.off(IMSDK.EVENT.READ_RECEIPT, this.onMsgReadReceipt);
    },

    // -----------------------  消息收发事件绑定 --------------------
    // 当收到新消息
    onNewMessage(data) {
      console.log('[onNewMessage]', data);
      for (const key of Object.keys(data)) {
        let array = data[key];
        if (this.toSyncMsgMap[key]) {
          array = this.toSyncMsgMap[key].concat(array);
        }
        this.$set(this.toSyncMsgMap, key, array);

        /* eslint-disable camelcase */
        const needReportMsgList = array.filter((item) => {
          /* eslint-disable max-len */
          const check_id = item?.msgHead?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.str_current_qidian_msg_unique_id;
          return check_id;
        });

        if (needReportMsgList.length > 0) {
          /* eslint-disable max-len */
          msgTracingEvent(needReportMsgList.map(item => ({
            check_id: item?.msgHead?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.str_current_qidian_msg_unique_id,
            kfuin: this.wpaDetail.kfuin,
            kfext: this.globalData?.reception?.extuin,
            event_name: 'msg_receive_success',
            event_cost_ms: 0,
            msg_time_ms: item.time,
            msg_dir: 'b2c',
          })));
        }
      }
    },

    // 当收到新push通知
    onPushNotify(data) {
      console.log('[onPushNotify]', data);

      // this.toNotifyMsgMap = {};
      for (const key of Object.keys(data)) {
        let array = data[key];
        if (this.toNotifyMsgMap[key]) {
          array = this.toNotifyMsgMap[key].concat(array);
        }
        this.$set(this.toNotifyMsgMap, key, array);
      }
    },

    // sdk的本地上屏灰条消息
    onLocalNotify(data) {
      this.showTipMessage({
        message: data.content || this.$t(data.type),
      });
    },

    /**
     * 对方正在输入
     */
    onTyping(data) {
      const { typing } = data || {};
      console.log('onTyping', typing);

      // 如果没有人接待时则不处理此事件，防止会话结束后仍然推送typing事件的问题。
      if (!this.currExtuin) {
        return;
      }

      // 输入状态持续时间。为什么是60s这么久？因为账号中心里就是这么写的 @_@
      const TYPING_TIME = 60 * 1000;
      const clearTyping = () => {
        // 时间到了之后，如果之前的typing消息还在消息队列中，就清除它
        this.typingTimer = setTimeout(() => {
          if (this.isLastIsTypingMsg()) {
            this.messageList.pop();
          }
        }, TYPING_TIME);
      };

      // 这里对取消输入 状态做一下延时。如果过快的取消输入状态，那么消息列表会闪一下。
      // 加入这个延时后，如果没有时间戳消息插入，那么输入状态就可以和文本消息无痕转换。
      clearTimeout(this.untypingTimer);
      if (!typing) {
        // 如果是取消输入， 则关闭状态，并关闭定时
        this.untypingTimer = setTimeout(() => {
          if (this.isLastIsTypingMsg()) {
            this.messageList.pop();
            this.typingTimer && clearTimeout(this.typingTimer);
          }
        }, 1000);
        return;
      }


      if (this.isLastIsTypingMsg()) {
        // 如果最后一条消息是输入中，需要清除后重新计时
        this.typingTimer && clearTimeout(this.typingTimer);
        clearTyping();
        return;
      }

      // 否则模拟一条 【正在输入...】消息
      const seq = StringUtils.generateUUID();
      const msg = {
        seq,
        type: MsgType.MSG_TYPING,
        time: Date.now(),
        // 将当前接待这的工号存入，这样才能在显示【正在输入】的时候显示正确的客服形象
        crm: { msg_webim_extra_data: { uint64_extuin: this.globalData?.reception?.extuin } },
      };
      this.addMessageList(msg, MsgOrder.Sync, false);
      // typing模拟生成之后要定时清除
      clearTyping();

      // 监测是否要滚动到底部
      if (getScrollBottom() < scrollLimit) {
        this.scrollToBottom();
      }
    },
    async getEmployeeInfo(kfext) {
      if (this.employeeInfoMap[kfext]) {
        return this.employeeInfoMap[kfext];
      }
      const { kfuin } = this.wpaDetail;
      const body = {
        kfext,
        kfuin,
        fields: ['employeeInfo'],
      };

      // 如果工号存在，并且是客服接待，则同时获取员工信息
      await fetchCompanyInfo(body, ({ employeeInfo = {} }) => {
        const { code: codeC, data: dataC } = employeeInfo;
        if (0 === codeC) {
          // 使用企业信息中 的名称和头像，设置B侧客服默认形象
          this.employeeInfoMap[kfext] = dataC;
        }
      });
      return this.employeeInfoMap[kfext];
    },
    // qq 邀请
    async onInviteQQ(data) {
      // 这里分为qq主号还是qq工号
      // 1：企业主号接待，2：员工接待
      if (this.guidanceInfo.guidanceQQType === 1) {
        this.createQQInviteCard(
          {
            avatar: this.companyInfo.companyLogo || require('@/static/img/default-avatar.png'),
            name: this.companyInfo.companyName || '',
            qq: data.data.uint64_kfuin || '',
          },
          {
            dir: 'b2c',
          },
        );
      } else {
        const employeeInfo = await this.getEmployeeInfo(data.data.uint64_ext_uin);
        this.createQQInviteCard(
          {
            avatar: data.data.string_qq_pic_url || require('@/static/img/default-avatar.png'),
            name: data.data.string_show_name || '',
            corpName: (employeeInfo && employeeInfo.company) || '',
            position: (employeeInfo && employeeInfo.position) || '',
            qq: data.data.uint64_ext_uin || '',
          },
          {
            dir: 'b2c',
          },
        );
      }
    },
    onReceiveQQCard(data) {
      console.log('[sc', data);
      this.createAddQQFriendCard(
        {
          avatar: data.data.string_pic_url || require('@/static/img/default-avatar.png'),
          name: data.data.string_show_name || '',
          qq: data.data.uint64_add_friend_uin || '',
        },
        {
          dir: 'b2c',
        },
      );
    },
    // 接待信息变更
    onReceptionChange(data) {
      console.log('[onReceptionChange]', data);
      this.customReport({
        method: '[onReceptionChange]',
        message: {
          reception: data,
        },
      });
      // 直接覆盖接待信息。
      this.globalData.reception = data;
    },
    /**
     * 获取机器人延迟输入配置
     * @param {*} robotId
     */
    fetchDelayConfig(robotId) {
      this.$ajax.post(`${ROBOT_REPLAY_DELAY}?corpUin=${this.wpaDetail.kfuin}`, {
        corpUin: this.wpaDetail.kfuin,
        robotId,
      }).then((res) => {
        const { code, data = {} } = res.data;
        if (+code === 0) {
          // 用接口返回值更新本地配置
          const { maximum, promptOpen } = data;
          this.globalData.robotDelay.time = maximum;
          this.globalData.robotDelay.switch = data.switch;
          this.globalData.robotDelay.promptOpen = promptOpen;
        }
      })
        .catch((e) => {
          console.log('fetchDelayConfig_catch', e);
        });
    },
    /**
     * 监测最后一条消息是【正在输入】的特殊消息
     */
    isLastIsTypingMsg() {
      const lastMsg = this.messageList[this.messageList.length - 1];
      return lastMsg && (lastMsg.type === MsgType.MSG_TYPING);
    },

    // 当IMready时
    onImsdkReady() {
      // 初始化上报
      this.initQidianDA();
      // IMready时，进行进线。
      const params = {
        // 进线自定义参数
        // 因为中文传递后，会持续乱码。因此先移除 encodeURI。 by justin. 20230612
        customParams: qs.stringify({ vId: myLocalStorage.getItem('tencentSig'), ...this.wpaDetail }),
      };
      if (this.authConf.authType) {
        params.userInfo = this.authTempUserInfo;
      }
      imsdk.clientIncoming(params);

      this.$emit('ready');

      this.postDisplayedCount();
    },
    // 获取上报已显示的外显消息
    postDisplayedCount() {
      const { wpaId, kfuin } = this.wpaDetail;
      const { aid, appid, d2 } = this.loginConfig;
      window.parent.postMessage({
        act: 'ON_IMSDK_READY',
        data: {
          aid,
          d2,
          appid,
          kfuin,
          wpaId,
        },
      }, '*');

      // let displayObj = {};
      // try {
      //   displayObj = JSON.parse(sessionStorage.getItem(`displayObj${wpaId}_${kfuin}`) || '{}');
      // } catch (error) {
      //   console.log('无痕模式？', error);
      // }
      // // 没有外显就不上报
      // if (!displayObj.ruleNum) return;
      // const params = {
      //   ruleID: displayObj.ruleId,
      //   msgNum: displayObj.ruleNum,
      // };
      // authAjax.post(`${DISPLAY_MESSAGE_ON_C}?kfuin=${kfuin}`, params).then((res) => {
      //   if (res.code === 0) {
      //     console.log('上报已经显示的外显消息', JSON.parse(res));
      //   }
      // })
      //   .catch((err) => {
      //     console.error('err 上报已经显示的外显消息', err);
      //   });
    },

    // 当会话接入成功
    onSessionStart() {
      // 进线成功后才拉取历史消息等
      if (!isInWhiteList(this.wpaDetail.kfuin, 'NOT_LOAD_HISTORY_MSG')) {
        // 白名单用户不加载历史消息
        this.onHistoryMessageClick(true, true);
      }

      this.isIMReady = true;

      // 未读消息已读上报。简易版本。
      imsdk.setMessageRead({ to: this.to.id });

      this.$emit('sessionStart');

      // 进线成功之后移除。如果不移除的话，当客户配置了【静默进线】时，改tip不会被自动移除。
      // 加入延迟是为了等待漫游消息拉取。
      this.updataIncomingTip(this.$t('chat_incoming_success'));
      setTimeout(() => {
        this.removeIncomingTip(true);
      }, 500);
      // 是否展示语言提示消息
      if (globalWin.translate) {
        globalWin.translate.isTranslate = this?.showInfo?.isTranslate;
      }
      // 上屏切换语言提示
      if (globalWin.translate && globalWin.translate.translateSwitch) {
        this.sendLangTip();
        this.setLangRequest(this?.$i18n?.locale);
      }
    },

    // 当被提出时
    onKickedOut() {
      this.isKickAlertShowing = true;
      this.$emit('kickedOut');
      // 弹框：你已被踢下线，点击确定重新登录
      // 弹框点击后重新连接。
      this.$Alert({ text: '您打开了多个会话页面，可激活当前页面继续咨询', alertText: '继续咨询' })
        .then(() => {
          // 直接reload。后续优化方案：1. 清理消息列表。2. 重新连接
          // location.reload();
          imsdk.reConnect();
          this.isKickAlertShowing = false;
        })
        .catch(() => { });
    },

    /**
     * RTC通话通知
     * @param {*} data
     */
    onNotifyRtc(data) {
      console.log('[onNotifyRtc]', data);
      this.$emit('notifyRtc', data);
    },

    /**
     * 出错处理。
     */
    onError(error) {
      // 错误码
      // AUTH_SVR_D2_TOKEN_EXPIRE          = -10001,
      // AUTH_SVR_CHECK_TOKEN_FAIL = -10002,
      // AUTH_SVR_INVALID_TICKET           = -10007,
      // AUTH_SVR_TICKET_DISMATCH          = -10008,
      // kConndRetTokenExpired             = -1000001,
      // kConndRetTokenError               = -1000002,
      // timeout -324012,
      console.log('[onError]', error);
      const { code } = error;
      const errorTypes = {
        timeout: [-324012],
        d2Error: [-10002, -10007, -10008, -1000002],
        d2Expire: [-10001, -1000001],
      };

      // 归总一下type
      Object.assign(error, { type: '' });
      Object.keys(errorTypes).forEach((k) => {
        if (errorTypes[k].indexOf(code) > -1) {
          Object.assign(error, { type: k });
        }
      });

      if (error.type === 'timeout') {
        this.showIncomingTimeout();
      }

      this.$emit('error', error);
    },

    /**
     * 消息【已读回执】事件
     */
    onMsgReadReceipt() {
      this.getMessageReadReceiptResult();
    },

    // -----------------------  消息收发处理 --------------------
    /**
     * @param {object} item 消息体
     * @param {number} order 插入序列。0-实时同步消息(push)， 1-历史漫漫消息(unshift)
     * @param {boolean} mine 是否【我的】消息
     * @returns void
     */
    addMessageList(item, order, mine) {
      // 机器人电商模板消息如果不是实时的，不进列表
      if (this.isRobotReversoMsg(item)) {
        if (order !== MsgOrder.Sync) {
          return;
        }
        // 机器人电商结构化消息进列表的时候记录一下，发送文本的时候清除掉
        this.revoseMsgSeqList.push(item.seq);
      }
      // 先处理撤回消息(同步消息带来的)
      if (item.type === IMSDK.TYPES.MSG_REVOKE) {
        const { seq } = item;
        if (this.seqMessageMap.has(seq)) {
          const message = this.seqMessageMap.get(seq);
          message.type = IMSDK.TYPES.MSG_REVOKE;
        }
        return;
      }

      // 去重
      if (this.seqMessageMap.has(item.seq)) {
        return;
      }

      if (this.isRobotDrawerMsg(item) && order === MsgOrder.Sync) {
        this.showRobotDrawer(item);
        return;
      }

      if (item.type === IMSDK.TYPES.MSG_ROBOT_FORM) {
        // 机器人表单消息，不进消息列表，直接弹出表单填写。
        this.showRobotForm(item);
        return;
      }

      if (this.isLastIsTypingMsg()) {
        // 有新消息进入时，如果最后一条消息是【正在输入...】，那就移除它
        this.messageList.pop();
        // 同时要清理定时器
        this.typingTimer && clearTimeout(this.typingTimer);
      }

      // bToc插入序列需要看0时出现未读消息的问题.
      // 要过滤掉 时间戳消息 和 正在输入消息
      if (order === MsgOrder.Sync
        && getScrollBottom() > scrollLimit
        && ![MsgType.MSG_DATETIME, MsgType.MSG_TYPING].find(mType => mType === item.type)) {
        this.notReadNumber += 1;
      }

      // 消息，基础信息。其他消息中都有这些信息（灰条，时间等除外）
      let message = {
        seq: item.seq,      // 唯一序列
        type: item.type,    // 消息类型，对应 IMSDK.TYPES
        time: item.time,    // 消息时间，毫秒
        status: typeof (item.status) !== 'undefined' ? item.status : MsgStatus.Success,   // 消息状态，对应 MsgStatus
        mine,   // 是否【我的】消息
        crm: item.crm, // 额外信息
        fromHisotry: order === MsgOrder.Roaming, // 是否历史消息
        msgHead: item.msgHead, // 原始消息Hrader
        msgBody: item.msgBody, // 原始消息body
        // SDK中下发的长文本，会被压缩处理。所以要调用解压接口。下方其他数据在下载解压时需要用到
        compressed: item?.compressed || item?.content?.compressed || 0,
        // 是否老webim的漫游消息
        isOldRoamingMsg: item.isOldRoamingMsg,
        // 实时c2b消息是否是从其他端同步过来的。应对未来C测可以多点登录的场景。仅队C2B消息有效。
        c2bSyncFromOtherClient: item.c2bSyncFromOtherClient || false,
      };

      // 【已读回执】逻辑处理
      // eslint-disable-next-line no-param-reassign
      message = this.checkAndSetMsgReadReceipt(message, order, mine);
      // 当页面可见时，收到的实时B2C消息回执【已读】
      if (this.pageVisibile && order === MsgOrder.Sync && !mine) {
        // 延迟处理，确保消息已经上屏
        setTimeout(() => {
          this.setMsgAllRead(message);
        }, 0);
      }

      switch (item.type) {
        case IMSDK.TYPES.MSG_TEXT:
          // 文本类型消息
          Object.assign(message, {
            content: item.content,
          });
          break;
        case IMSDK.TYPES.MSG_FACE:
          // 表情类型消息
          Object.assign(message, {
            content: [{
              index: item.index,
              content: item.content,
              type: IMSDK.TYPES.MSG_FACE,
            }],
            type: IMSDK.TYPES.MSG_MIX,
          });
          break;
        case IMSDK.TYPES.MSG_MEDIA:
          // 链接资源类型
          Object.assign(message, {
            mediaType: item.media_type,
            mediaUrl: item.media_url,
          });
          break;
        case IMSDK.TYPES.MSG_IMAGE:
          // 图片类型消息
          Object.assign(message, {
            path: item.content,
            uuid: item.uuid,
            imageName: item.name,
            imageSize: item.size,
            imageWidth: item.width,
            imageHeight: item.height,
          });
          break;
        case IMSDK.TYPES.MSG_LONG_MSG:
          // 长文本类型消息
          Object.assign(message, {
            path: item.content, // B2C消息解析出的content实际是长文本存储的path。
            uuid: item.uuid,
            previewContent: item.previewContent, // 本地预览内容
          });
          break;
        case IMSDK.TYPES.MSG_IMAGE_TEXT:
          // 图文类型消息(QQ规范XML)
          Object.assign(message, {
            path: item.path,
            uuid: item.uuid,
            content: item.content,
          });
          break;
        case IMSDK.TYPES.MSG_QDXML:
          // 图文类型消息(企点规范XML)
          Object.assign(message, {
            path: item.content.path,
            brief: item.content.brief,
            content: item.content.content,
          });
          break;
        case IMSDK.TYPES.MSG_ROBOT_NAV:
          // 机器人导航
          Object.assign(message, {
            path: item.content.path,
            content: item.content.content,
          });
          break;
        case IMSDK.TYPES.MSG_FILE:
          // 文件类型消息
          Object.assign(message, {
            path: item.content,
            uuid: item.uuid,
            fileName: item.name,
            fileSize: item.size,
            fileFormat: item.format,
          });
          break;
        case IMSDK.TYPES.MSG_VOICE:
          // 语音类型消息
          Object.assign(message, {
            path: item.content,
            uuid: item.uuid,
            length: item.length,
            fileSize: item.size,
            fileName: item.name,
          });
          break;
        case IMSDK.TYPES.MSG_MIX:
          // 混合类型消息
          Object.assign(message, {
            content: item.content,
          });
          break;
        case IMSDK.TYPES.MSG_GRAY:
          // 灰条类型消息
          Object.assign(message, {
            content: item.content,
          });
          break;
        case IMSDK.TYPES.MSG_FEED_BACK:
          // 满意度消息 -  注意，这个消息之前并不是server下发的，而是前端根据特殊链接点击后自己生成的
          Object.assign(message, {
            content: item.content,
          });
          break;
        case IMSDK.TYPES.MSG_THIRD_MSG:
          // 通用三方消息
          Object.assign(message, {
            content: item.content,
            // ***是否因此B侧客服信息。 如果不需要显示B侧客服信息，请将对应crmFlag放入数组中***
            // ***是否因此B侧客服信息。 如果不需要显示B侧客服信息，请将对应crmFlag放入数组中***
            // ***是否因此B侧客服信息。 如果不需要显示B侧客服信息，请将对应crmFlag放入数组中***
            hideBInfo: [60].indexOf(item.content.crmFlag) > -1,
          });
          break;
        case MsgType.MSG_LEAVE_FORM:
        // 机器人消息
        case IMSDK.TYPES.MSG_ROBOT:
          Object.assign(message, {
            content: item.content,
            // 实时消息并且打开开关配置了延迟输入且不展示正在输入
            isNeedHide: order === MsgOrder.Sync && this.isBubbleDelayShow(),
          });
          if (message.content && message.content.type === 18) {
            Object.assign(message, {
              type: MsgType.MSG_ROBOT_GOODS_NAV,
              content: item.content,
              // 实时消息并且打开开关配置了延迟输入且不展示正在输入
              isNeedHide: false,
              hideBInfo: true,
            });
          }
          break;
        case  MsgType.MSG_LEAVE_FORM:
          Object.assign(message, {
            hideBInfo: true,
          });
          break;
        case MsgType.MSG_INVITE_QQ:
          Object.assign(message, {
            hideBInfo: true,
          });
          break;
        default:
          // 其他类型消息
          Object.assign(message, {
            content: item.content,
          });
      }

      if (item.revoke === 1 || item?.msgHead?.uint32_status === 1) {
        // 这是一条被撤回的消息(漫游消息带来的)
        message.type = IMSDK.TYPES.MSG_REVOKE;
      }

      // 获取工号信息，异步回调，防止卡住消息渲染流程
      if (!mine) {
        // 1. 先给设置默认值
        this.$set(message, 'extuinInfo', defaultExtuinInfo());
        // 请求B侧员工信息。
        // 注：之前的逻辑是配置了显示员工信息时才请求。但是为了完成【引用回复】项目，需要全量的请求B测消息的发送者信息并存储起来。
        this.getExtuinInfo(message, (data) => {
          // extuinInfo —— 消息【对外显示】的信息。
          // extuinInfoReal —— 消息【真实发送者】信息。
          this.$set(message, 'extuinInfoReal', data);
          // 仅当配置了显示员工信息时才获取员工信息，否则默认未企业信息。
          if (this.serviceInfoShowType - 0 === 2) {
            this.$set(message, 'extuinInfo', data);
          }
        });
      }
      if (item.seq) {
        // 存入映射表
        this.seqMessageMap.set(item.seq, message);
        const interval = 2 * 60 * 1000; // 两分钟之内的消息合并展示
        if (order === MsgOrder.Sync) {
          // 实时同步消息
          if (item.time - MaxSyncMsgTime > interval && item.type !== MsgType.MSG_TYPING) {
            // 需要过滤 onTyping 时插入的假消息。
            // 插入时间节点
            this.messageList.push({
              // 给一个seq，否则漫游消息拉取后重新定位有问题
              seq: StringUtils.generateUUID(),
              type: MsgType.MSG_DATETIME,
              time: item.time,
            });
            MaxSyncMsgTime = item.time;
          }
          this.messageList.push(message);
          // 对外抛出事件
          if (mine) {
            this.$emit('sendC2BMessage', message);
          } else {
            this.$emit('receiveNewMessage', message);
          }
        } else if (order === MsgOrder.Roaming) {
          // 历史漫游消息
          this.messageList.unshift(message);
          if (MinRoamingMsgTime - item.time > interval) {
            // 插入时间节点
            this.messageList.unshift({
              seq: StringUtils.generateUUID(),
              type: MsgType.MSG_DATETIME,
              time: item.time,
            });
            MinRoamingMsgTime = item.time;
          }
        }
      }
    },
    // 是否机器人电商消息
    isRobotReversoMsg(message) {
      return message.type === IMSDK.TYPES.MSG_ROBOT && message.content.type === 7
      && message.content.content && message.content.content.type === 14;
    },

    /**
     * 设置【已读回执】信息
     * 所有消息都直接开启已读回执功能，开关只控制【已读/未读】标记的显示
     * ==================== 一下策略移除 ======================
     * 注意，这里有一个很重要的设定：
     * 【已读回执】开关队消息的作用是实时的。
     * 也就是说，开关关闭期间所发的消息，并不会被设置【已读回执】标记。
     * 当开关再次打开之后，这些历史消息将不展示已读/未读状态。
     * 判断逻辑：消息状态是否为已发送成功 && 【已读回执】开关是否开启 && 当前消息是否设置了【已读回执】tag
     * msg.status===MsgStatus.Success && msg.readStatusSwitch && msg.hasReadReceiptTag
     * =======================================================
     */
    checkAndSetMsgReadReceipt(item, order, mine) {
      // 需要比过滤掉的，不需要【已读回执功能】的消息
      const FILTER_MSG_TYPES = [IMSDK.TYPES.MSG_RTC];
      const msg = { ...item };
      // 过滤黑名单消息，直接返回
      if (FILTER_MSG_TYPES.indexOf(msg.type) > -1) {
        return msg;
      }

      if (mine) {
        // C2B消息：需要分别处理实时发送和漫游拉取的消息
        // 功能开关
        msg.readStatusSwitch = this.readStatusSwitch;

        if (
          order === MsgOrder.Sync
          && (this.globalData.reception.extuin || this.globalData.reception.inWaitPool)
        ) {
          // 1.1. C2B实时：需要检测是否要写入【已读回执】开关。
          // 已开启总开关，并且（a. 处于人工接待， 或者  b. 排队中）, 并且 不是黑名单消息。
          msg.hasReadReceiptTag = true;
          msg.hasBeenRead = false;
        } else if (order !== MsgOrder.Sync || msg.c2bSyncFromOtherClient) {
          // 1.2. C2B漫游 或从其他端同步过来的C2B实时消息：需要读取该消息当前【已读回执】状态
          Object.assign(msg, this.getMessageReadReceiptFromCrm(msg.crm));
        }
      } else {
        // 2.0. B2C：不论实时还是漫游，都统一读取【已读回执】状态
        Object.assign(msg, this.getMessageReadReceiptFromCrm(msg.crm));
      }
      return msg;
    },

    /**
     * 从 crm 信息中获得消息 已读回执 标记 和状态
     */
    getMessageReadReceiptFromCrm(crm) {
      const { int32_read_status: hasReadReceiptTag } = crm?.msg_control_info || {};
      return {
        hasReadReceiptTag: !!hasReadReceiptTag,
      };
    },

    /**
     * 将 阅读回执 状态写入crm信息
     */
    setMessageReadReceiptToCrm(message, imsdkMessage) {
      if (message.hasReadReceiptTag) {
        // eslint-disable-next-line no-param-reassign
        imsdkMessage = imsdk.setMessageCrmData(imsdkMessage, {
          // 阅读回执 标记位
          msg_control_info: {
            int32_read_status: 1,
          },
        });
      }
      return imsdkMessage;
    },

    /**
     * 将所有B2C消息已读
     */
    setMsgAllRead(latestMsg) {
      console.log('[setMsgAllRead]', 'check');
      // 找到最后一条需要【已读回执】的B2C消息
      if (!latestMsg && !this.messageList) {
        return;
      }
      let lastNeedReadReceiptMsg;
      if (latestMsg) {
        lastNeedReadReceiptMsg = latestMsg;
      } else {
        const b2cMsgList = this.messageList.filter(item => !item.mine && item.type !== MsgType.MSG_TYPING);
        lastNeedReadReceiptMsg = b2cMsgList[b2cMsgList.length - 1];
      }

      if (!lastNeedReadReceiptMsg || lastNeedReadReceiptMsg.type === MsgType.MSG_TYPING) {
        console.log('[setMsgAllRead]', '0000000000');
        return;
      }

      console.log('[setMsgAllRead]', lastNeedReadReceiptMsg.seq);

      const reportData = {
        clientTermType: 'c', // C侧上报时，固定为'c'
        cid: this.to.user_id,
        seq: lastNeedReadReceiptMsg.seq,
        time: Math.floor(lastNeedReadReceiptMsg.time / 1000), // 取整到 s 精度
      };

      this.customReport({
        method: '[setMsgAllRead][request]',
        message: reportData,
      });
      SDKUtils.reportMessageReadReceipt(reportData).then((res) => {
        const rs = res.data;
        this.customReport({
          method: '[setMsgAllRead][response]',
          message: rs,
        });
      })
        .catch((err) => {
          this.customReport({
            method: '[setMsgAllRead][error]',
            message: err,
          });
        });
    },

    /**
     * 获取消息已读未读结果
     */
    getMessageReadReceiptResult() {
      this.customReport({
        method: '[getMessageReadReceipt][request]',
      });
      SDKUtils.getMessageReadReceipt({ cid: this.to.user_id }).then((res) => {
        const rs = res.data;
        this.customReport({
          method: '[getMessageReadReceipt][request]',
          message: rs,
        });

        if (rs && !rs.code) {
          // 最后一条已读消息的时间戳
          let lastReadMsgTime = rs?.data?.get_msg_read_report_rsp?.b_read_info?.uint64_time;
          // 这里取到的是 s 。为了防止边界值判定有误，再次+1s后进行判定
          lastReadMsgTime -= 0; // ！！！server下发的可能是字符串，转化为数字
          lastReadMsgTime += 1;
          // 转化为ms，后续进行比对。
          lastReadMsgTime *= 1000;

          this.messageList.forEach((msg) => {
            if (lastReadMsgTime && msg.time <= lastReadMsgTime) {
              // 注意 hasBeenRead 有3种取值： true|false|undefined。
              // 当为undefined时，标识尚未成功获得消息状态，此时不显示任何阅读回执状态
              // code不为0则代表已经成功获取结果
              this.$set(msg, 'hasBeenRead', true);
            } else {
              this.$set(msg, 'hasBeenRead', false);
            }
          });
        }
      })
        .catch((err) => {
          this.customReport({
            method: '[getMessageReadReceipt][error]',
            message: err,
          });
        });
    },

    // 显示本地tip
    showTipMessage(data) {
      if (data.info && data.info.id) {
        const seq = data.info.id;
        const message = this.seqMessageMap.get(seq);
        this.$set(message, 'status', MsgStatus.Resend);
        this.$set(message, 'resendType', MsgResendType.UploadFailed);
        this.$set(message, 'resendInfo', data.info);
        this.$set(message, 'resendData', data.file);
      } else {
        const tip = {
          seq: StringUtils.generateUUID(),
          type: MsgType.MSG_TIP,
          content: data.message,
          time: Date.now(),
        };
        this.messageList.push(tip);
        this.scrollToBottom();
        return tip;
      }
    },

    // qq邀请卡片
    createQQInviteCard(body, payload) {
      // 如果工号存在，通过工号去拿工号的头像，昵称等信息
      // console.log('createQQInviteCard', this.wpaDetail, this.globalData);
      // 0. 消息预处理
      const message = {
        // 生成消息的唯一id
        seq: SDKUtils.generateUUID(),
        // 指定消息的类型
        type: MsgType.MSG_INVITE_QQ,
        // 消息的通用信息，包括：状态，时间，和 接收者
        ...this.previewMsgCommongData(),
        status: MsgStatus.Success,
        hideBInfo: true,
        msgBody: {
          ...body,
        },
      };
      // 1. 上屏显示
      // item, order, mine, trueBottom = true
      this.addMessageList(message, MsgOrder.Sync, payload.dir === 'c2b');
      setTimeout(() => {
        this.scrollToBottom();
      });
    },
    // 添加qq好友卡片消息
    createAddQQFriendCard(body, payload) {
      // 0. 消息预处理
      const message = {
        // 生成消息的唯一id
        seq: SDKUtils.generateUUID(),
        // 指定消息的类型
        type: MsgType.MSG_ADD_QQ_CARD,
        // 消息的通用信息，包括：状态，时间，和 接收者
        ...this.previewMsgCommongData(),
        status: MsgStatus.Success,
        // 将当前接待这的工号存入，这样才能在显示【正在输入】的时候显示正确的客服形象
        crm: { msg_webim_extra_data: { uint64_extuin: this.globalData?.reception?.extuin } },
        msgBody: {
          ...body,
        },
      };
      // 1. 上屏显示
      // item, order, mine, trueBottom = true
      this.addMessageList(message, MsgOrder.Sync, payload.dir === 'c2b');
      setTimeout(() => {
        this.scrollToBottom();
      });
    },

    // 留言消息
    createLeaveMessage(body, payload) {
      // 0. 消息预处理
      const message = {
        // 生成消息的唯一id
        seq: SDKUtils.generateUUID(),
        // 指定消息的类型
        type: MsgType.MSG_LEAVE_FORM,
        // 消息的通用信息，包括：状态，时间，和 接收者
        ...this.previewMsgCommongData(),
        status: MsgStatus.Success,
        hideBInfo: true,
        msgBody: {
          ...body,
        },
      };
      // 1. 上屏显示
      // item, order, mine, trueBottom = true
      this.addMessageList(message, MsgOrder.Sync, payload.dir === 'c2b');
      setTimeout(() => {
        this.scrollToBottom();
      });
    },

    /**
     * 发送文本消息
     * @param {string | Array<{type:string, content:string}>} chatMessage 发送的消息内容
     */
    sendTextMessage(chatMessage, extCrmData = {}) {
      // 获取基本信息，方便给用户远程调试
      if (chatMessage === '*#*#180805#*#*') {
        this.$Alert(`<div style="font-size:12px;">${JSON.stringify({ wpaDetail: this.wpaDetail, to: this.to, reception: this.globalData.reception })}</div>`);
        return;
      }
      // 强制刷新页面
      if (chatMessage === '*#*#180808#*#*') {
        window.location.reload(true);
        return;
      }
      // 清除localStroage并强制刷新页面
      if (chatMessage === '*#*#365612#*#*') {
        localStorage.clear();
        window.location.reload(true);
        return;
      }

      // 大于500字，要转化为长文本发送。
      const MAX_SHORT_TXT_NUM = 500;
      // 兼容一下输入直接为字符串的情况
      if (typeof (chatMessage) === 'string') {
        if (chatMessage.length > MAX_SHORT_TXT_NUM) {
          this.sendLongTextMessage(chatMessage);
          return;
        }
        // eslint-disable-next-line no-param-reassign
        chatMessage = StringUtils.coverEmojiIndex2ImgMessage(chatMessage);
      }
      // 生成一个临时seq
      const tempSeq = StringUtils.generateUUID();
      let message = {
        seq: tempSeq,
        ...this.previewMsgCommongData(),
      };
      if (chatMessage.length === 1) {
        const item = chatMessage[0];
        if (item.type === 'text') {
          message.type = IMSDK.TYPES.MSG_TEXT;
          message.content = item.content;
        } else if (item.type === 'media_resources') {
          message.type = IMSDK.TYPES.MSG_MEDIA;
          message.media_type = item.mediaType;
          message.media_url = item.mediaUrl;
        } else if (item.type === 'face') {
          message.type = IMSDK.TYPES.MSG_MIX;
          message.content = chatMessage;
        }
      } else {
        message.type = IMSDK.TYPES.MSG_MIX;
        message.content = chatMessage;
      }


      this.addMessageList(message, MsgOrder.Sync, true);
      this.deleteRevoseMsg();
      this.scrollToBottom();

      // 以下为底层消息发送
      message = this.seqMessageMap.get(tempSeq);
      const crmData = {
        qd_source_msg: this.sourceMsg,
        str_lang: this.$i18n.locale,  // 新增语言类型
      };
      if (Object.keys(extCrmData).length) {
        Object.assign(crmData, extCrmData);
      }
      const imsdkMessage = imsdk.createTextMessage({
        to: this.to.id,
        payload: {
          ...this.commonPayload,
          text: chatMessage,
          crmData,
        },
      });

      // 这里为了方便和后期兼容，设置一个私有变量，存储回复的消息内容
      if (this.sourceMsg) {
        this.$set(message, '$_sourceMsg', this.sourceMsg);
      }

      this.sourceMsg = null;

      // 3. 发送消息
      this.innerSendMessage(message, imsdkMessage);
    },

    // 消息上屏预览
    onPreviewImage(info) {
      const message = {
        type: IMSDK.TYPES.MSG_IMAGE,
        ...this.previewMsgCommongData(),
        seq: info.id,
        content: info.path,
        uuid: info.uuid,
        name: info.name,
        size: info.size,
        width: info.width,
        height: info.height,
      };
      this.addMessageList(message, MsgOrder.Sync, true);

      this.scrollToBottom();
    },
    // 上传成功后发送消息
    onSendImageMessage(data) {
      if (data.code !== 0) {
        this.showTipMessage(data);
        return;
      }

      const { info } = data;
      // 发送图片消息
      const imgId = info.id;
      const message = this.seqMessageMap.get(imgId);
      // 更新本地数据，用于查看本地上传的图片
      Object.assign(message, {
        tempPath: info.path,
      });
      const imsdkMessage = imsdk.createImageMessage({
        to: this.to.id,
        payload: {
          ...this.commonPayload,
          image: {
            uuid: info.uuid,
            path: info.path,
            name: info.name,
            size: info.size,
            width: info.width,
            height: info.height,
          },
        },
      });

      // 3. 发送消息
      this.innerSendMessage(message, imsdkMessage);
    },

    // 消息上屏预览
    onPreviewFile(info) {
      const message = {
        type: IMSDK.TYPES.MSG_FILE,
        ...this.previewMsgCommongData(),
        seq: info.id,
        content: info.path,
        uuid: info.uuid,
        name: info.name,
        size: info.size,
        format: info.format,
      };
      this.addMessageList(message, MsgOrder.Sync, true);
      this.scrollToBottom();
    },
    // 文件上传进度控制
    onFileProgress(info, progress, controller) {
      const fileId = info.id;
      const message = this.seqMessageMap.get(fileId);
      // 处理上传进度
      this.$set(message, 'uploadProgress', progress);
      this.$set(message, 'progressController', controller);
    },
    // 上传成功后发送消息
    onSendFileMessage(data) {
      if (data.code !== 0) {
        this.showTipMessage(data);
        return;
      }
      const { info } = data;
      // 发送文件消息
      const fileId = info.id;
      const message = this.seqMessageMap.get(fileId);
      // 更新本地数据，使用上传后的数据
      Object.assign(message, {
        uuid: info.uuid,
        path: info.path,
      });
      const imsdkMessage = imsdk.createFileMessage({
        to: this.to.id,
        payload: {
          ...this.commonPayload,
          file: {
            uuid: info.uuid,
            path: info.path,
            name: info.name,
            size: info.size,
            format: info.format,
          },
        },
      });

      // 3. 发送消息
      this.innerSendMessage(message, imsdkMessage);
    },

    // 消息上屏预览
    onPreviewVoice(info) {
      const message = {
        type: IMSDK.TYPES.MSG_VOICE,
        ...this.previewMsgCommongData(),
        seq: info.id,
        content: info.path,
        uuid: info.uuid,
        name: info.name,
        size: info.size,
        format: info.format,
        length: info.length,
      };
      this.addMessageList(message, MsgOrder.Sync, true);
      this.scrollToBottom();
    },
    // 上传成功后发送消息
    onSendVoiceMessage(data) {
      if (data.code !== 0) {
        this.showTipMessage(data);
        return;
      }
      const { info } = data;
      // 发送文件消息
      const fileId = info.id;
      const message = this.seqMessageMap.get(fileId);
      Object.assign(message, {
        uuid: info.uuid,
        path: info.path,
      });
      const imsdkMessage = imsdk.createVoiceMessage({
        to: this.to.id,
        payload: {
          ...this.commonPayload,
          ptt: {
            uuid: info.uuid,
            path: info.path,
            name: info.name,
            size: info.size,
            format: 0, // 0 - amr
            length: info.length, // 时长
          },
        },
      });

      // 3. 发送消息
      this.innerSendMessage(message, imsdkMessage);
    },


    /**
     * 上传长文本处理
     */
    async uploadLongT(params) {
      const rs = await SDKUtils.uploadLongText(params).catch(() => Promise.reject(null));
      if (!rs.code && rs.info && rs.info.uuid) {
        return rs.info.uuid;
      }
      return Promise.reject(null);
    },
    // 发送企点xml结构化消息
    sendQDXMLMessage(data, resendMessage = null, extCrmData = {}) {
      if (data.qdxml && data.qdxml.content) {
        const promiseArray = [];

        const { qdxml } = data;
        if (qdxml) {
          if (qdxml.resid) {
            promiseArray.push(Promise.resolve(qdxml.resid));
          } else if (qdxml.content) {
            promiseArray.push(this.uploadLongT(qdxml.content));
          }
        }

        const { text } = data;
        if (text) {
          if (text.resid) {
            promiseArray.push(Promise.resolve(text.resid));
          } else if (text.content) {
            promiseArray.push(this.uploadLongT(text.content));
          }
        }
        // 生成一个临时seq
        let tempSeq = null;
        let tempMessage = {};
        let message;
        if (!resendMessage) {
          tempSeq = SDKUtils.generateUUID();
          tempMessage = {
            type: IMSDK.TYPES.MSG_QDXML,
            ...this.previewMsgCommongData(),
            seq: tempSeq,
            content: {
              path: '',
              brief: qdxml.brief,
              content: qdxml.content,
            },
          };
          this.addMessageList(tempMessage, MsgOrder.Sync, true);
          message = this.seqMessageMap.get(tempSeq);
          setTimeout(() => {
            this.scrollToBottom();
          }, 200);
        } else {
          message = resendMessage;
        }
        Promise.all(promiseArray).then((values) => {
          let commonControlMsg = '';
          if (values[0]) {
            commonControlMsg = {
              str_control_msg_resid: values[0],
              str_msg_brief: qdxml.brief || '',
              bytes_structure_content: qdxml.content || '',
            };
          }

          let thirdPartyMsg = '';
          if (values[1]) {
            thirdPartyMsg = {
              string_res_id: values[1],
              string_msg_brief: text.brief || '',
              string_msg_content: text.content || '',
            };
          }
          const crmData = {};
          if (Object.keys(extCrmData).length) {
            Object.assign(crmData, extCrmData);
          }
          const imsdkMessage = imsdk.createQDXMLMessage({
            to: this.to.id,
            payload: {
              ...this.commonPayload,
              qdXml: {
                msg_common_control_msg_info: commonControlMsg,
                msg_third_party_msg_info: thirdPartyMsg,
              },
              crmData,
            },
          });
          // 3. 发送消息
          this.innerSendMessage(message, imsdkMessage);
        })
          .catch(() => {
            this.$set(message, 'status', MsgStatus.Invalid);
            this.$set(message, 'resendType', MsgResendType.UploadFailed);
            this.$set(message, 'resendData', data);
          });
      }
    },

    /**
     * 发送菜单消息。如：切换客服，机器人转接消息等
     */
    sendQDMenuMessage(params) {
      // 目前仅直接调用，不做其他处理
      return imsdk.sendInnerClickEvent(params).then((rs) => {
        // 非机器人接待状态时点击历史消息中的机器人导航 的 错误处理。
        if (rs?.msg_ret_info?.uint32_ret_code === 3111629) {
          this.customReport({
            method: '[sendQDMenuMessage-error]',
            message: params,
            code: rs?.msg_ret_info?.uint32_ret_code,
          });
          this.showTipMessage({ message: '机器人会话已结束，暂不支持机器人导航点击' });
        }
        return rs;
      });
    },

    /**
     * 发送长文本消息
     */
    async sendLongTextMessage(content, resendMessage = null) {
      const tempSeq = SDKUtils.generateUUID();
      let message;
      if (!resendMessage) {
        message = {
          type: IMSDK.TYPES.MSG_LONG_MSG,
          ...this.previewMsgCommongData(),
          seq: tempSeq,
          previewContent: content, // 本地预览内容
        };
        this.addMessageList(message, MsgOrder.Sync, true);
        this.scrollToBottom();
        // 从map中获得message对象，因为 addMessageList 会更改原始的message。
        message = this.seqMessageMap.get(tempSeq);
      } else {
        message = resendMessage;
      }
      const path = await this.uploadLongT(content).catch(() => {
        this.$set(message, 'status', MsgStatus.Invalid);
        this.$set(message, 'resendType', MsgResendType.UploadFailed);
        this.$set(message, 'resendData', content);
        console.log('长文本出错了', tempSeq);
        return;
      });
      console.log('我还是发送了', tempSeq);
      const imsdkMessage = imsdk.createLongTextMessage({
        to: this.to.id,
        payload: {
          ...this.commonPayload,
          long_msg: {
            uuid: path,
            path,
            length: content.length,
            brief: content.substr(0, 20),
          },
        },
      });

      // 3. 发送消息
      this.innerSendMessage(message, imsdkMessage);
    },

    /**
     * @desc 发送只上屏消息 only text
     * @param {object} msg - 上屏消息
     */
    sendOnlyInvisibleMessage(msg) {
      const tempSeq = StringUtils.generateUUID();
      const message = {
        seq: tempSeq,
        ...this.previewMsgCommongData(),
      };
      message.status = MsgStatus.Success;
      if (msg.type === 'text') {
        message.type = IMSDK.TYPES.MSG_TEXT;
      }
      message.content = msg.content;
      this.addMessageList(message, MsgOrder.Sync, true);
      this.scrollToBottom();
    },
    // 根据消息id滚动到该消息位置
    handleReplayMsgClick(id) {
      const node = document.querySelector(`.msg_${id}`);
      console.log(node);
      if (node) {
        scrollIntoView(node, {
          scrollMode: 'if-needed',
          block: 'nearest',
          inline: 'nearest',
        });
        // 给目标消息增加闪动效果
        node.classList.add('flicker');
        node.addEventListener('animationend', () => {
          node.classList.remove('flicker');
        }, {
          once: true,
        });
      } else {
        this.$Toast({ text: '无法定位原消息', type: 'error' });
      }
    },
    // 复制消息
    handleCopyMsg(text) {
      this.$copyText(text)
        .then(() => {
          this.$Toast(this.$t('chat_add_friend_copy_success_msg'));
        }, () => {
          this.$Toast({ text: '复制失败，请重试', type: 'error' });
        });
    },
    // 格式化回复消息的文本
    replayTextFormat(text) {
      /* eslint-disable no-param-reassign */
      if (text && text.length > 30) {
        text = `${text.substr(0, 27)}...`;
      }
      return text;
    },
    formaySummary(msg) {
      if (!msg) {
        return '转换错误';
      }
      switch (msg.type) {
        case IMSDK.TYPES.MSG_TEXT: {
          const { content } = msg;
          return this.replayTextFormat(content);
        }
        case IMSDK.TYPES.MSG_FILE:
          return '[文件]';
        case IMSDK.TYPES.MSG_IMAGE:
          return '[图片]';
        case IMSDK.TYPES.MSG_VOICE:
          return '[语音]';
        case IMSDK.TYPES.MSG_QDXML:
          return '[结构化消息]';
        case IMSDK.TYPES.MSG_IMAGE_TEXT:
          return '[图文消息]';
        case IMSDK.TYPES.MSG_LONG_MSG: {
          const { _processedText } = msg;
          return this.replayTextFormat(_processedText);
        }
        case IMSDK.TYPES.MSG_MIX: {
          let result = '';
          msg.content.forEach((item) => {
            if (item.type === IMSDK.TYPES.MSG_FACE) {
              result += '[表情]';
            } else if (item.type === IMSDK.TYPES.MSG_TEXT) {
              result += item.content;
            }
          });
          return result;
        }
        default:
          return '[未知消息类型]';
      }
    },
    // 回复消息
    handleReplayMsg(msg) {
      const senderName = (msg?.extuinInfoReal?.innerName || '');
      const LEN_LIMIT = 12; // 长度限制12个字符（...计算在内）
      /* eslint-disable max-len */
      const sourceMsg = {
        uint32_msg_direction: msg.mine ? 1 : 2,
        uint64_time: parseInt(msg.time, 10),
        bytes_summary: this.formaySummary(msg),
        str_reference_qidian_msg_unique_id: msg?.msgHead?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.str_current_qidian_msg_unique_id,
        // 从消息【真实发送者】信息中获取发送者内部名字。长度限制12个字符（...计算在内，算3个）
        str_sender_name: senderName.length > LEN_LIMIT ? `${senderName.substr(0, LEN_LIMIT - 3)}...` : senderName,
      };
      this.sourceMsg = sourceMsg;
      this.scrollToBottom(false, 0);
    },
    // 重发消息
    resendMessage(message) {
      const tempSeq = message.seq;
      this.$set(message, 'status', MsgStatus.Sending);

      if (message.resendType === MsgResendType.TimeOut) {
        const check_id = message?.check_id;
        // 上报计算耗时需要
        const startTime = Date.now();
        const resendSeq = message.resendData;
        const promise = imsdk.resendMessage(resendSeq);
        promise
          .then((res) => {
            this.afterSendSucc(message, res);
            this.seqMessageMap.delete(tempSeq);
            msgTracingEvent([{
              check_id,
              kfuin: this.wpaDetail.kfuin,
              kfext: this.globalData?.reception?.extuin,
              event_cost_ms: Date.now() - startTime,
              msg_time_ms: res.time,
            }]);
          })
          .catch(() => {
            msgTracingEvent([{
              check_id,
              kfuin: this.wpaDetail.kfuin,
              event_name: 'msg_send_error',
              kfext: this.globalData?.reception?.extuin,
              evnet_ret_code: -1,
              event_cost_ms: Date.now() - startTime,
            }]);
            this.$set(message, 'status', MsgStatus.Resend);
          });
      } else if (message.resendType === MsgResendType.UploadFailed) {
        console.log('[UploadFailed]', message);
        if (message.type === IMSDK.TYPES.MSG_IMAGE) {
          this.$refs.imageUploader.uploadFile(message.resendData, message.resendInfo);
        } else if (message.type === IMSDK.TYPES.MSG_FILE) {
          this.$refs.fileUploader.uploadFile(message.resendData, message.resendInfo);
        } else if (message.type === IMSDK.TYPES.MSG_VOICE) {
          this.$refs.voiceUploader.uploadFile(message.resendData, message.resendInfo);
        } else if (message.type === IMSDK.TYPES.MSG_QDXML) {
          this.sendQDXMLMessage(message.resendData, message);
        } else if (message.type === IMSDK.TYPES.MSG_LONG_MSG) {
          this.sendLongTextMessage(message.resendData, message);
        }
      } else {
        console.log('[resendMessage] 特殊错误，不进行重发');
        // 直接失败
        this.$set(message, 'status', MsgStatus.Resend);
      }
    },

    /**
     *消息发送及结果处理
     */
    innerSendMessage(message, imsdkMessage) {
      const  tempSeq  = message.seq;
      // ------ Start: 消息发送前预处理 ------
      // 处理【已读回执】标记，放到crm信息中
      imsdkMessage = this.setMessageReadReceiptToCrm(message, imsdkMessage);
      // ------ End: 消息发送前预处理 ------

      const promise = imsdk.sendMessage(imsdkMessage);
      robotReport.before.call(this, imsdkMessage);
      /* eslint-disable camelcase */
      const check_id = imsdkMessage?.msg_send_req?.msg_send_msg?.msg_msg_head?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.str_current_qidian_msg_unique_id;
      // 上报计算耗时需要
      const startTime = Date.now();
      promise
        .then((res) => {
          robotReport.after.call(this, res);
          // 本地生成的消息没有 head 和 body，这里设置回去
          /* eslint-disable max-len */
          this.$set(message, 'msgHead', imsdkMessage?.msg_send_req?.msg_send_msg?.msg_msg_head);
          this.$set(message, 'msgBody', imsdkMessage?.msg_send_req?.msg_send_msg?.msg_msg_body);

          if (res.code) {
            // 发送失败
            const { error } = res;
            this.afterSendFail(message, res, error);
            return;
          }
          msgTracingEvent([{
            check_id,
            kfuin: this.wpaDetail.kfuin,
            kfext: this.globalData?.reception?.extuin,
            event_cost_ms: Date.now() - startTime,
            msg_time_ms: res.time,
          }]);

          // 这里发生成功之后会往seq MessageMap里重新写入key值为svr返回的seq的值
          this.afterSendSucc(message, res);
          // 从seqMessageMap中删除key值为临时seq的值
          this.seqMessageMap.delete(tempSeq);
        })
        .catch((error) => {
          msgTracingEvent([{
            check_id,
            kfuin: this.wpaDetail.kfuin,
            event_name: 'msg_send_error',
            kfext: this.globalData?.reception?.extuin,
            evnet_ret_code: -1,
            event_cost_ms: Date.now() - startTime,
          }]);
          // 保存消息id，重发的时候使用
          this.$set(message, 'check_id', check_id);
          // 发送出错处理
          this.setDataAfterError(message, error);
        });
    },

    // 发送成功后统一修改message
    afterSendSucc(message, res) {
      // 使用server的值覆盖本地的值
      this.$set(message, 'syncseq', res.syncseq);
      this.$set(message, 'sidesyncseq', res.sidesyncseq);
      this.$set(message, 'seq', res.seq);
      this.$set(message, 'time', res.time);
      // 更新消息状态为 Success
      this.$set(message, 'status', MsgStatus.Success);
      // 更新本地的临时seq，使用server返回的seq
      this.seqMessageMap.set(res.seq, message);

      // 发送成功事件
      this.$emit('sendC2BMessageSuccess', message);
    },

    /**
     * 发送失败的处理
     */
    afterSendFail(message, res) {
      const { error } = res;
      this.$set(message, 'status', MsgStatus.Invalid);
      this.showTipMessage({
        message: error,
      });
    },

    // 发送出错后统一修改message
    setDataAfterError(message, error) {
      this.$set(message, 'status', MsgStatus.Resend);
      this.$set(message, 'resendType', MsgResendType.TimeOut);
      this.$set(message, 'resendData', error.seq);
    },

    // 加载更多消息
    onHistoryMessageClick(scrollToBottom, isFirstGet) {
      this.isLoading = true;
      this.getRoamingMessage(isFirstGet).then((imResponse) => {
        if (this.messageList.length > 0) {
          // 拉取新消息后恢复滚动条位置
          this.recoverScrollbarAfterPullHistoryMsg();
        }

        // 记录一下消息请求到的时间
        this.lastFetchRoamingTime = Date.now();

        console.log('[roamingMsg]', imResponse);

        const { nextReqMessageSeq, nextReqMessageTime, isCompleted, messageList, isOldRoamingMsg } = imResponse;
        // 兼容处理新老漫游消息返回。
        // 新漫游返回 nextReqMessageSeq， 老漫游返回 nextReqMessageTime。
        // 新漫游
        if (typeof (nextReqMessageSeq) !== 'undefined') {
          this.roamingMsgSeq = nextReqMessageSeq;
          this.isMoreMessageNew = !isCompleted;

          // 此时，应将新满意消息最后一条消息的时间戳记录到this.roamingOldMsgTime, 这样在拉取完新漫游消息之后，才能正常拉取老漫游消息.
          if (messageList.length > 0) {
            // 注意时间要修正到微秒。并且加一。
            this.roamingOldMsgTime = messageList[messageList.length - 1].time * 1000 + 1;
          }
        }
        // 老webim漫游
        if (typeof (nextReqMessageTime) !== 'undefined') {
          this.roamingOldMsgTime = nextReqMessageTime;
          this.isMoreMessageOld = !isCompleted;
        }
        // 只要任意一个有消息，则就是真的还有
        this.isMoreMessage = this.isMoreMessageNew || this.isMoreMessageOld;

        for (const item of messageList) {
          // 过滤掉特殊场景下content为空情况(比如:存在msg_track_info)
          if (!item.content && !item.path) {
            continue;
          }

          // 标记一下是老的漫游消息
          if (isOldRoamingMsg) {
            item.isOldRoamingMsg = true;
            // 因为默认seq是0，所以设置一个seq
            (item.seq === 0) && (item.seq = item.time * 1000);
          }

          if (item.to === this.to.id) {
            this.addMessageList(item, MsgOrder.Roaming, true);
          } else if (item.from === this.to.id) {
            this.addMessageList(item, MsgOrder.Roaming, false);
          } else {
            console.warn('☹️☹️☹️☹️☹️☹️===>msg_kfuin_error', item.to, this.to.id);
          }
        }

        // 当已经拉取了所有漫游消息，并且第一条消息不是时间(且消息有time字段)，并且不是进线tip消息，
        // 那么先移除最近的一条时间消息，然后在首位插入一条时间消息
        const firstMsg = this.messageList[0];
        if (!this.isMoreMessage && firstMsg && firstMsg.time
          && firstMsg.type !== MsgType.MSG_DATETIME
          && !this.isIncomingTip(firstMsg)
        ) {
          const firstTimeMsg = this.messageList.findIndex(item => item.type === MsgType.MSG_DATETIME);
          if (firstTimeMsg > 0) {
            this.messageList.splice(firstTimeMsg, 1);
          }
          // 插入时间节点
          this.messageList.unshift({
            seq: StringUtils.generateUUID(),
            type: MsgType.MSG_DATETIME,
            time: firstMsg.time,
          });
          MinRoamingMsgTime = firstMsg.time;
        }

        // 获得这些漫游消息的已读状态
        this.getMessageReadReceiptResult();
        // 上报已读
        this.setMsgAllRead();
      })
        .finally(() => {
          this.isLoading = false;
          if (scrollToBottom) {
            this.scrollToBottom(false, 10);
          }

          if (isFirstGet) {
            // 第一次请求
            setTimeout(() => {
            // 当没有新的漫游消息了，就拉一次老的。
              if (!this.isMoreMessageNew && this.isMoreMessageOld) {
                this.onHistoryMessageClick(scrollToBottom);
              }
            }, 100);
          }
        });
    },

    /**
     * 拉取漫游消息
     */
    getRoamingMessage(isFirstGet) {
      // 是否是拉取老漫游消息
      // 如果不是第一次拉取，并且新漫游也拉完了，则应该拉老漫游
      const isGetOld = !isFirstGet && !this.isMoreMessageNew;
      if (isGetOld) {
        return imsdk.getOldMessageList({
          to: this.to.id,
          end: this.roamingOldMsgTime, // 注意这个参数，和下面的不同
          payload: {
            ...this.commonPayload,
          },
        });
      }

      return imsdk.getMessageList({
        to: this.to.id,
        seq: this.roamingMsgSeq,
        payload: {
          ...this.commonPayload,
        },
      });
    },

    // ws 拉取工号信息
    async fetchExtuinInfo(extuin, isRobot) {
      console.log('[fetchExtuinInfo]', extuin, isRobot);
      return imsdk.fetchExtuinInfo({ extuin, kfuin: +this.wpaDetail.kfuin }, isRobot);
    },
    // 获取工号信息，由消息item组件调用
    async getExtuinInfo(msg, callback) {
      let uInfo;
      // 读取extuin信息，默认为0。
      const extData = msg?.crm?.msg_webim_extra_data;
      const isRobot = !!extData?.uint64_robotid ; // 人工客服或者机器人的id
      const extuin = isRobot ? extData?.uint64_robotid : extData?.uint64_extuin; // 人工客服或者机器人的id

      // 如果工号与主号相同，则说明 不是员工下发的信息，就不继续了。直接终止。
      if (String(extuin) === String(this.wpaDetail.kfuin)) {
        return;
      }

      // console.log(43234234 ,'1111', extData);
      // 当首次拉取到漫游消息时，会有大量的头像请求，将这些请求集中起来处理。
      if (!this.getExtuinInfoCBList) {
        this.getExtuinInfoCBList = {};
      }
      if (!this.getExtuinInfoCBList[extuin]) {
        this.getExtuinInfoCBList[extuin] = {
          loading: false,
          callbacks: [],
        };
      }
      this.getExtuinInfoCBList[extuin].callbacks.push(callback);

      // 如果当前extuin信息的获取正在执行，那就直接返回
      if (this.getExtuinInfoCBList[extuin].loading) {
        return;
      }
      // 获取头像信息
      this.getExtuinInfoCBList[extuin].loading = true;
      try {
        uInfo = await getOrFetchExtuinInfo(extuin, extuin => this.fetchExtuinInfo(extuin, isRobot));
      } catch (ex) {
        uInfo = defaultExtuinInfo();
      }
      this.getExtuinInfoCBList[extuin].loading = false;

      // 信息获取成功后，执行所有的回调。
      if (this.getExtuinInfoCBList && this.getExtuinInfoCBList[extuin]) {
        this.getExtuinInfoCBList[extuin].callbacks.forEach((cb) => {
          cb(uInfo);
        });
      }
    },

    /**
     * 发送cmd消息
     */
    sendCmdMessage(...args) {
      return imsdk.sendCmdMessage(...args);
    },

    /**
     *  获取socket链接状态
     */
    getSocketConnected() {
      return imsdk?.getSocket()?.connectManage?.socketIO?.socket?.connected;
    },

    /**
     * 监听页面显示，监测是否要主动重连。
     * why? 因为当页面长时间被隐藏是，会触发节流机制，从而导致socket断开。
     * 详情：https://developer.chrome.com/blog/timer-throttling-in-chrome-88/#intensive-throttling
     */
    checkIfNeedReconnect() {
      // 页面显示时清理通知
      document.addEventListener('visibilitychange', () => {
        // 如果页面切换到可见状态了
        if (document.visibilityState === 'visible') {
          // 当IM已经ready了，并且socket连接是false状态，并且没有显示被提下线提示
          if (this.isIMReady && this.getSocketConnected() === false && !this.isKickAlertShowing) {
            this.customReport({
              method: 'checkIfNeedReconnect',
              message: '[reConnet][visibilitychange]',
            });
            imsdk.reConnect();
          }
        }
      });
    },

    // --------------------------- End: 消息发送处理 ---------------------------------
    /**
     * 展示机器人信息收集表单
     */
    showRobotForm(msg) {
      console.log(msg);
      const RobotForm = Vue.extend(MsgRobotForm);
      new RobotForm({ propsData: { data: msg, vm: this } }).$mount();
    },
    /**
     * 展示抽屉型结构化消息
     */
    showRobotDrawer(msg) {
      const RobotDrawer = Vue.extend(MsgRobotDrawer);
      new RobotDrawer({ propsData: {
        message: msg,
        to: this.to,
        wpaDetail: this.wpaDetail,
        globalData: this.globalData,
      } }).$mount();
    },

    /**
     * msg.type是判断是机器人消息
     * msg.content.type === 7 是 机器人模板消息
     * msg.content.content.type = 14 是电商模板消息，因为还有个16是物流节点模板消息
     * templateId == 2|5是抽屉样式的消息 聚合/不聚和
     */
    isRobotDrawerMsg(msg) {
      return msg.type === IMSDK.TYPES.MSG_ROBOT && msg.content
      && msg.content.type === 7
      && msg.content.content && msg.content.content.type === 14
      && (msg.content.content.templateId === 5 || msg.content.content.templateId === 2);
    },

    /**
     * 初始化营销上报
     */
    initQidianDA() {
      // 将im的vid写入到营销上报的cookie中
      // if (window.document && window.document.cookie) {
      //   const setRaw = function (key, value, expires) {
      //     let newCookie = `${key}=QD.${value}; `;

      //     if (expires !== null) {
      //       const date = new Date();
      //       date.setTime(date.getTime() + expires);
      //       newCookie += `expires=${date.toGMTString()}; `;
      //     }

      //     const doc = window.document;
      //     doc.cookie = newCookie;
      //   };
      //   const ONE_YEAR = 1000 * 60 * 60 * 24 * 365;
      //   setRaw('_qddaz', this.to.user_id, ONE_YEAR);
      // }

      // 修改da上报域名
      let daDomain = '';
      if (!process.env.BRANCH_ENV || process.env.BRANCH_ENV === 'saas') { // Saas正式环境
        daDomain = 'https://v.qidian.qq.com';
      } else if (process.env.BRANCH_ENV === 'oa' || location.host.indexOf('localhost') > -1) {
        // Saas OA 或 本地测试
        daDomain = 'https://oa.v.qidian.qq.com';
        // daDomain = 'https://oaim.kefutcs2.qidian.qq.com/v'; // 私有化二期
      } else {
        // 私有化
        daDomain = `https://v-${location.host}/v`;
      }
      // 私有化需要先设置域名
      window.qidianDA('setDomain', daDomain);

      // 设置通用上报数据，其他上报均会包含此数据
      window.qidianDA(
        'setCommonData',
        {},
        { da_rpt_type: 'wpa',
          wpa_id: this.wpaDetail.wpaId,
        },
      );

      // 初始化并进行设置。
      window.qidianDA(
        'create',
        this.wpaDetail.kfuin,
        '',
        {
          preventAutoTrack: true,
        },
      );

      // 照搬saas逻辑
      window.qidianDA('setValsByHand', { appkey: '', da_rpt_type: 'wpa' });

      this.sendDAInitReport();
    },

    // 上报初始化数据
    sendDAInitReport() {
      const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
      const eventtp = params.linkType === '0' ? 2 : 3;
      const localClickId = this.wpaDetail.clickid;
      // 照搬Saas的逻辑，但是很多参数没有
      const reportObj = {
        mid: '',
        id: this.wpaDetail.wpaId,
        kfuin: this.wpaDetail.kfuin,
        kfext: params.kfext || '',
        cate: params.cate || '',
        type: params.type || '',
        eventtp,
        tpForm: eventtp,
        refurl: typeof document.referrer !== 'undefined' ? document.referrer : '',
        ua: navigator.userAgent,
        eptype: this.$platform.pc ? 1 : 2,
        // eslint-disable-next-line no-underscore-dangle
        pid: params._pid || localClickId,
        clickid: localClickId,
        clickType: 6, // webim 固定值
        visitorid: this.to.user_id,
        tptype: 9, // webim 固定值
      };

      const wpaTptypeName = {
        0: '未知',
        1: '企业WPA',
        2: '员工WPA',
        3: '免费电话',
        4: '加QQ群',
        5: '加QQ好友',
        6: '公众号人工客服',
        7: '会话',
        8: '关注公众号',
        9: 'webim',
      };
      const wpaCategory = {
        1: 'QQ接待',
        3: '公众号推广',
        4: '群推广',
        5: '员工推广',
        7: '网页接待',
        8: '企点接待',
        101: '电话接待',
      };
      function checkExit(val) {
        return Boolean(val || val === 0);
      };

      window.qidianDA('track', 'webim_aio_open', {
        wpa_visitorid: checkExit(reportObj.visitorid) ? Number(reportObj.visitorid) : '',
        wpaid: checkExit(reportObj.id) ? Number(reportObj.id) : '',
        wpa_category_id: checkExit(reportObj.cate) ? Number(reportObj.cate) : '',
        wpa_category: checkExit(reportObj.cate) ? String(wpaCategory[reportObj.cate] || '') : '',
        wpa_type: checkExit(reportObj.type) ? Number(reportObj.type) : '',
        kfext: checkExit(reportObj.kfext) ? Number(reportObj.kfext) : '',
        wpa_eventtp: checkExit(reportObj.eventtp) ? Number(reportObj.eventtp) : '',
        wpa_tptype: checkExit(reportObj.tptype) ? Number(reportObj.tptype) : '',
        wpa_tptype_name: checkExit(reportObj.tptype) ? String(wpaTptypeName[reportObj.tptype] || '') : '',
        wpa_clickid: checkExit(reportObj.clickid) ? String(reportObj.clickid) : '',
        wpa_sm: checkExit(reportObj.sm) ? String(reportObj.sm) : '',
        wpa_cckey: String(params.cckey || ''),
      });
    },

    // 保证消息列表增加历史消息后滚动位置不变
    recoverScrollbarAfterPullHistoryMsg() {
      if (this.messageList.length > 0) {
        // TOFIX
        // 保证消息列表增加历史消息后滚动位置不变
        const { seq } = this.messageList[0];
        // 消息列表外围可滚动的容器
        const eleMessageList = document.querySelector('.page-scroll-container');
        // 消息列表中的第一条消息
        const eleMsgItem = eleMessageList.querySelector(`.msg-item[seq="${seq}"]`);
        // 第一步: 取第一个消息离滚动窗口的距离preOffsetTop
        const preOffsetTop = eleMsgItem.offsetTop - eleMessageList.scrollTop;

        setTimeout(() => {
          // 第二步: 用scrollIntoView与滚动窗口顶端尽量对齐
          eleMsgItem.scrollIntoView(true);
          // 第三步: 再取一次离滚动窗口的距离afterOffsetTop
          const afterOffsetTop = eleMsgItem.offsetTop - eleMessageList.scrollTop;
          // preOffsetTop - afterOffsetTop 之差就是滚动窗口要向往下滚动的距离
          eleMessageList.scrollTop -= preOffsetTop - afterOffsetTop;
        }, 10);
      }
    },

    // 滚动到底部 - 通过一个dom来处理
    scrollToBottom(smooth = true, delay = 200) {
      const { scrollToBottom } = this.$refs;

      if (!scrollToBottom) {
        console.error('页面中不存在节点 <div ref="scrollToBottom"></div>');
      }

      // 如果页面滚动的距离太长了，那么就直接滚动到底部不使用动画。
      // 或3秒之内拉取过大量漫游消息，就临时禁止滚动动画
      // 否则动画将持续太久会，从而造成无法滚动到底的问题。
      const needScrollHeihgt = getScrollBottom();
      if (needScrollHeihgt > 600 || (Date.now() - this.lastFetchRoamingTime) < 3 * 1000) {
        smooth = false;
        console.warn('[scrollToBottom]', 'scroll without animation!');
      }

      this.notReadNumber = 0;
      setTimeout(() => {
        if (smooth) {
          scrollToBottom.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        } else {
          scrollToBottom.scrollIntoView(true);
        }
      }, delay);
    },

    scrollChange: throttle(function () {
      if (getScrollBottom() < scrollLimit) {
        this.notReadNumber = 0;
      }
      console.log('this.notReadNumber', this.notReadNumber);
    }, 100),

    /**
     * 检查是否需要滚动到页面底部
     * @param {bool} noAnimation 是否是漫游消息
     */
    checkIfNeedScrollToBottom(noAnimation) {
      if (getScrollBottom() < scrollLimit) {
        // 如果是从漫游中拉倒的历史消息，则不需要动画
        if (noAnimation) {
          globalWin.scrollToBottom(false, 10);
        } else {
          globalWin.scrollToBottom(true, 500);
        }
      }
    },

    /**
     * 创建进线时显示的tip消息
     */
    createIncomingTip(content) {
      if (this.incomingTipMsg) {
        // 全局唯一，防止重复创建
        if (content) {
          this.updataIncomingTip(content);
        }
        return;
      }
      const msg = this.showTipMessage({
        message: content || this.$t('chat_incoming'),
      });
      this.incomingTipMsg = msg;
    },

    /**
     * 移除incoming tip
     */
    removeIncomingTip(force) {
      if (this.incomingTipMsg) {
        const { seq } = this.incomingTipMsg;
        const tipIndex = this.messageList.findIndex(item => item.seq === seq);
        if (tipIndex > -1 && (this.messageList.length > 1 || force)) {
          // 必须有多条消息的时候才移除 incoming
          this.messageList.splice(tipIndex, 1);
          this.incomingTipMsg = null;
        }
      }
    },

    /**
     * 更新进线tip
     */
    updataIncomingTip(content) {
      if (this.incomingTipMsg) {
        const { seq } = this.incomingTipMsg;
        const tipIndex = this.messageList.findIndex(item => item.seq === seq);
        if (tipIndex > -1) {
          this.messageList[tipIndex].content = content;
        }
      }
    },

    /**
     * 监测是否是进线tip消息。
     */
    isIncomingTip(msg) {
      if (this.incomingTipMsg && this.incomingTipMsg.seq === msg.seq) {
        return true;
      }
      return false;
    },

    /**
     * 显示进线超时错误
     */
    showIncomingTimeout() {
      const msg = this.inIframe ? 'chat_incoming_timeout_inframe' : 'chat_incoming_timeout';
      // login timeout
      this.updataIncomingTip(this.$t(msg));
    },

    /**
     * 获取服务端和本地消息时间差异。数据上报会用到
     */
    getServerClientTimeDiff() {
      if (isPrivate) {
        // 私有化不支持这个逻辑
        return Promise.resolve(0);
      }

      const { kfuin } = this.wpaDetail;
      const reqTime = +new Date();

      return new Promise((resolve, reject) => {
        this.$ajax.head('/webim/commonRequest/checkTime', { timeout: 1000, data: { kfuin } }).then((res) => {
          const resTime = +new Date();
          const serverNow = +new Date(res.header.Date || resTime);
          const precision = parseInt((resTime - reqTime) / 2, 10);
          const diff = serverNow + precision - resTime;
          console.log('[getServerClientTimeDiff]', diff);
          resolve(diff);
        })
          .catch(err => reject(err));
      });
    },

    /**
     * 为自动化测试暴露外部数据
     * @param {*} evt
     * @param {*} msg
     */
    storageMessageForTest() {
      const storageMsg = (evt, msg) => {
        // 上报用的数据，移除head和body
        const tmpMsg = Object.assign({}, msg);
        delete tmpMsg.msgHead;
        delete tmpMsg.msgBody;
        // 上报数据
        this.customReport({
          method: evt,
          vistorid: this.to.user_id,
          kfuin: this.wpaDetail.kfuin,
          message: tmpMsg,
        }, 'webim');

        // 当外部环境有这个变量时，则将消息抛出给它
        if (window.testMsgRecords) {
          if (!window.testMsgRecords[evt]) {
            window.testMsgRecords[evt] = [];
          }
          window.testMsgRecords[evt].push(msg);
        }
      };

      // 抛出数据，用于自动化测试
      this.$on('receiveNewMessage', (msg) => {
        storageMsg('receiveNewMessage', msg);
      });
      this.$on('sendC2BMessage', (msg) => {
        storageMsg('sendC2BMessage', msg);
      });
      this.$on('sendC2BMessageSuccess', (msg) => {
        storageMsg('sendC2BMessageSuccess', msg);
      });

      // 外部debug，自动化测试
      if (location.href.indexOf('debug=1') > -1) {
        window.imsdkDebuger = imsdk;
        window.aioDebuger = this;
      }
    },
    // 在消息列表中隐藏/或展示消息的逻辑,目前只做了展示的逻辑，需要隐藏逻辑的时候再加
    switchMsgDisplay(seq, action) {
      if (!seq || !action) {
        return;
      }
      const itemIdx =  this.messageList.findIndex(item => item.seq === seq);
      if (itemIdx < 0) {
        return;
      }
      if (action === 'show') {
        this.messageList[itemIdx].isNeedHide = false;
      }
      if (action === 'delete') {
        this.messageList.splice(itemIdx, 1);
      }
    },

    // 是否延迟展示气泡
    isBubbleDelayShow() {
      return this.globalData.robotDelay.switch && !this.globalData.robotDelay.promptOpen;
    },
    /**
     * 发送文本消息之后清除列表中的机器人电商消息
     */
    deleteRevoseMsg() {
      this.revoseMsgSeqList.forEach((item) => {
        this.switchMsgDisplay(item, 'delete');
      });
    },
    /**
     * 撤回消息
     * @param {*} message
     */
    revokeMsg(message) {
      const promise = imsdk.revokeMessage({
        to: this.to.id,
        payload: {
          user_id: this.to.user_id,
          user_type: this.to.user_type,
          pubacc_id: this.to.pubacc_id,
          message,
        },
      });
      promise.then((res) => {
        if (res.code) {
          this.showTipMessage({
            message: res.error,
          });
        } else {
          this.$set(message, 'origin_type', message.type);
          this.$set(message, 'type', IMSDK.TYPES.MSG_REVOKE);
          this.$set(message, 'revoke_mine', true);
          if (message.seq === this.messageList[this.messageList.length - 1].seq) {
            // 撤回的消息是最后一条
            this.$emit('sendMessage', {
              type: IMSDK.TYPES.MSG_REVOKE,
              to: this.to,
              content: '你撤回了一条消息',
              time: message.time,
            });
          }
        }
      })
        .catch((error) => {
          console.error('error', error);
          this.showTipMessage({
            message: '撤回消息超时,请稍后重试',
          });
        });
    },
    // 传递robotMsg的信息到B测
    transferRobotMsg(msg) {
      console.log('transferRobotMsg', msg);
      this.$emit('transferRobotMsg', msg);
    },
    // 传递录音的信息到B侧
    voiceRecodeStatus(msg) {
      console.log('voiceRecodeStatus', msg);
      this.$emit('voiceRecodeStatus', msg);
    },
    /**
     * 发送语言灰条提示消息
     */
    sendLangTip(isChangeLang) {
      const text = isChangeLang ? this.$t('sysmsg_msg_change_service_lang') : this.$t('sysmsg_msg_current_service_lang');
      const msg = {
        content: {
          gray: `${text}：<a href="javascript:;" data-type="changeLang" class="btn-lang">${this.$t('lang')}</a>`,
        },
        type: 'gray_msg',
        seq: StringUtils.generateUUID(),
        time: Date.now(),
        status: 0,
      };
      this.addMessageList(msg, 0, false);
      this.scrollToBottom();
    },


    // 发送设置语言的请求
    setLangRequest(lang = '') {
      return new Promise((resolve, reject) => {
        const params = {
          kfuin: globalWin.kfuin,
          visitId: this.to.user_id,
          // 繁体中文后台的参数要求和前端存储的值不一致，这里转换一下
          translateLang: lang === 'zh-TW' ? 'zh-tw' : lang,
        };
        this.$ajax.post(SWITCH_LANG, params)
          .then((res) => {
            const { code } = res.data;
            if (+code === 0) {
              // 切换语言
              this.$setLocale(lang);
              resolve();
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
          });
      });
    },
  },
};
